<template>
  <ReadinessDashboard
    title="DORA Readiness"
    subtitle="Digital Operational Resilience Act — ICT risk & third-party posture"
    endpoint-path="dora-readiness"
    :actions="actions"
    :category-order="categoryOrder"
  />
</template>

<script>
import { computed } from 'vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import ReadinessDashboard from '../components/ReadinessDashboard.vue'

export default {
  name: 'DORADashboardView',
  components: { ReadinessDashboard },
  setup() {
    const store = useStore()
    const route = useRoute()
    const tenantId = computed(() => route.params.tenantId || store.getters.currentTenantId)

    const actions = computed(() => {
      const t = tenantId.value
      if (!t) return {}
      return {
        products_defined:   { route: `/tenants/${t}/products`,        label: 'Add Product' },
        sbom_coverage:      { route: `/tenants/${t}/products`,        label: 'Upload SBOMs' },
        vuln_disclosure:    { route: `/tenants/${t}/vulnerabilities`, label: 'Manage Vulns' },
        incident_tracking:  { route: `/tenants/${t}/incidents`,       label: 'Track Incidents' },
        third_party_risk:   { route: `/tenants/${t}/products`,        label: 'SBOM Coverage' },
        security_contact:   { route: `/tenants/${t}/products`,        label: 'Set Contact' },
        vdp:                { route: `/tenants/${t}/settings`,        label: 'Enable VDP' },
        resilience_testing: { route: `/tenants/${t}/compliances`,     label: 'Add Evidence' },
        public_docs:        { route: `/tenants/${t}/documents`,       label: 'Publish Docs' },
      }
    })

    const categoryOrder = [
      'ICT Risk Management',
      'Incident Reporting',
      'Third-Party Risk',
      'Resilience Testing',
      'Information Sharing',
      'Documentation'
    ]

    return { actions, categoryOrder }
  }
}
</script>
